import PropTypes from "prop-types";

import { Button, connect } from 'components/atoms/DependencyHelper';
import Image from "components/atoms/image/image";

import {
  useDeviceStockStatus,
  useInclusionStockStatus,
  useDealInCartStatus
} from "utils/hooks/dealDetails";

import {
  componentResize,
  imagePrefix,
} from "utils/helperServices";

import labels from "../../../config/labels";
import types from "../../../config/types";

import styles from "./DealSpecificationControl.module.scss";

const DealSpecificationControl = (props) => {
  const isMobile = componentResize();
  const { isInStock: isDeviceInStock } = useDeviceStockStatus();
  const { isInStock: isInclusionInStock }  = useInclusionStockStatus();
  const isDealInCart = useDealInCartStatus();

  const isAddToCart = props.buyOption && props.buyOptions && props.buyOption === props.buyOptions[0]?.title;
  const isUpgrade = props.buyOption && props.buyOptions && props.buyOption === props.buyOptions[1]?.title;
  const isViewCart = isDealInCart && !isMobile;

  const disableAddToCart = !isDeviceInStock 
    || !isInclusionInStock
    || isDealInCart
    || props.isBackOrderDealUnavailable;
  const disableUpgrade = props.ctaText === labels.deal_details.lbl_add_deal_cart
    && (!isDeviceInStock || isDealInCart)
    || !isDeviceInStock
    || !isInclusionInStock
    || (props.userLoggedIn && props.eligibleUpgradeList.length == 0);

  const variant_addToCart = (props.promoTag !== types.TYPE_PREORDER && props.addDealToCartEnabled)
    ? "success"
    : "danger";
  const variant_upgrade = props.promoTag == types.TYPE_PREORDER
    ? "danger"
    : props.ctaText === labels.deal_details.lbl_add_deal_cart
      ? "success"
      : "danger";

  return (
    <div className={styles["button-container"]}>
      <div className={`${styles.sticky_on_mobile}`}>
        {isAddToCart && (
          <Button
            variant={variant_addToCart}
            className={`mb-xs ${styles["addToCartBtn"]} 
              ${ disableAddToCart ? styles["disabled"] : "" }`
            }
            block
            onClick={() =>
              props.handleAddToCart(
                props.addDealToCartEnabled
                  ? labels.deal_details.lbl_deal_to_cart
                  : labels.deal_details.lbl_get_this_deal
              )
            }
            disabled={disableAddToCart}
          >
            { props.addDealToCartEnabled && props.promoTag != types.TYPE_PREORDER && (
              <i className="v-icon-cart-s"> </i>
            )}

            { props.promoTag == types.TYPE_PREORDER
              ? labels.lbl_preorder_now
              : props.addDealToCartEnabled
                ? labels.deal_details.lbl_deal_to_cart
                : labels.deal_details.lbl_get_this_deal}
          </Button>
        )}

        {isUpgrade && (
          
            <Button
              onClick={() => props.handleUpgrade(props.ctaText)}
              variant={variant_upgrade}
              className={`mb-xs  ${styles["addToCartBtn"]} 
                ${ disableUpgrade ? styles["disabled"] : ""}`
              }
              block
              disabled={disableUpgrade}
            >
              {props.ctaText === labels.deal_details.lbl_add_deal_cart &&
                props.promoTag !== types.TYPE_PREORDER && (
                  <i className="v-icon-cart-s"> </i>
                )}
              {props.ctaText}
            </Button>
        )}

        {isViewCart && (
            <Button
              variant="dark"
              className={`mb-xs  ${styles["viewcart-btn"]}`}
              onClick={props.viewCart}
              block
              id={`${props.dealSKU}-ViewCart`}
            >
              <Image
                className="mr-2"
                img_path={`${imagePrefix}/assets/images/arrow-right-small-copy-2.svg`}
                img_width="1.125rem"
                img_height="1.125rem"
              />
              {labels.lbl_view_cart}
            </Button>
        )}            
      </div>
    </div>
  );
}

const BuyOptionProps = PropTypes.shape({
  option_type_id: PropTypes.number,
  price_type: PropTypes.string,
  sku: PropTypes.string,
  title: PropTypes.string,
});

DealSpecificationControl.propTypes = {
  addDealToCartEnabled: PropTypes.bool,
  buyOptions: PropTypes.arrayOf(BuyOptionProps),
  ctaText: PropTypes.string,
  handleAddToCart: PropTypes.func,
  handleUpgrade: PropTypes.func,
  isBackOrderDealUnavailable: PropTypes.bool,
  viewCart: PropTypes.func,
  
  // Redux
  buyOption: PropTypes.string,
  dealSKU: PropTypes.string,
  eligibleUpgradeList: PropTypes.arrayOf(PropTypes.object),
  promoTag: PropTypes.string,
  userLoggedIn: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
  buyOption: state.dealDetails.selectedApplicationType?.title || "",
  dealSKU: state.dealDetails.selectedDealDetails?.sku || "",
  promoTag: state.dealDetails.selectedDealDetails?.promotion_tag_label || "",
  userLoggedIn: state.navDetails.isUserLoggedIn,
})

export default connect(mapStateToProps, {})(DealSpecificationControl);